import { LIVE, LiveConfig, SeatLive } from "@/data/live";

export interface LiveTally {
  party: string;
  won: number;
  leading: number;
  total: number; // won + leading
}

export function liveTally(cfg: LiveConfig = LIVE): LiveTally[] {
  const m = new Map<string, { won: number; leading: number }>();
  Object.values(cfg.seatStatus).forEach((s: SeatLive) => {
    if (s.status === "pending") return;
    const cur = m.get(s.party) ?? { won: 0, leading: 0 };
    if (s.status === "won" || s.status === "won_unofficial" || s.status === "won_official") cur.won += 1;
    else if (s.status === "leading") cur.leading += 1;
    m.set(s.party, cur);
  });
  return Array.from(m.entries())
    .map(([party, v]) => ({ party, won: v.won, leading: v.leading, total: v.won + v.leading }))
    .sort((a, b) => b.total - a.total || b.won - a.won);
}

/**
 * Tally by component party (sub field). If sub is missing, falls back to coalition.
 * Returns rows sorted by total seats descending.
 */
export function livePartyTally(cfg: LiveConfig = LIVE): LiveTally[] {
  const m = new Map<string, { won: number; leading: number }>();
  Object.values(cfg.seatStatus).forEach((s: SeatLive) => {
    if (s.status === "pending") return;
    const key = s.sub || s.party; // use component party if available
    const cur = m.get(key) ?? { won: 0, leading: 0 };
    if (s.status === "won" || s.status === "won_unofficial" || s.status === "won_official") cur.won += 1;
    else if (s.status === "leading") cur.leading += 1;
    m.set(key, cur);
  });
  return Array.from(m.entries())
    .map(([party, v]) => ({ party, won: v.won, leading: v.leading, total: v.won + v.leading }))
    .sort((a, b) => b.total - a.total || b.won - a.won);
}

export function liveTotals(cfg: LiveConfig = LIVE) {
  let won = 0;
  let leading = 0;
  Object.values(cfg.seatStatus).forEach((s) => {
    if (s.status === "won" || s.status === "won_unofficial" || s.status === "won_official") won += 1;
    else if (s.status === "leading") leading += 1;
  });
  const declared = won;
  const counted = won + leading;
  const pending = cfg.totalSeats - counted;
  return { won, leading, declared, counted, pending };
}
